import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Dates = {
    CREATED_AT: CreatedAt,
    COMPLETED_AT: CompletedAt,
    CANCELLED_AT: CancelledAt,
    LAST_UPDATED: lastUpdated,
    DAY: () => (
        <FormattedMessage
            id='dates.day'
            description={'label for day'}
            defaultMessage='Day'
        />
    ),
    HOUR: () => (
        <FormattedMessage
            id='dates.hour'
            description={'label for hour'}
            defaultMessage='Hour'
        />
    ),
    MONTH: () => (
        <FormattedMessage
            id='dates.month'
            description={'label for month'}
            defaultMessage='Month'
        />
    )
};

export function CreatedAt(text?: React.ReactNode) {
    return (
        <FormattedMessage
            id='dates.created-at'
            description='Created at date'
            defaultMessage='Created at {text}'
            values={{ text }}
        />
    );
}

export function CompletedAt(text?: React.ReactNode) {
    return (
        <FormattedMessage
            id='dates.completed-at'
            description='Completed at date'
            defaultMessage='Completed at {text}'
            values={{ text }}
        />
    );
}

export function CancelledAt(text?: React.ReactNode) {
    return (
        <FormattedMessage
            id='dates.cancelled-at'
            description='Cancelled at date'
            defaultMessage='Cancelled at {text}'
            values={{ text }}
        />
    );
}

export function lastUpdated(text?: React.ReactNode) {
    return (
        <FormattedMessage
            id='dates.last-updated'
            description='Last updated date'
            defaultMessage='Last updated {text}'
            values={{ text }}
        />
    );
}
